import { Building2, Globe, UserCheck, AlertTriangle } from "lucide-react";
import { Reveal, SectionHeading } from "./shared";
import { useLanguage } from "@/i18n/LanguageContext";

export default function BeforeYouGo() {
  const { t } = useLanguage();
  const ITEMS = [
    { icon: Building2, title: t("b1Title"), desc: t("b1Desc") },
    { icon: Globe, title: t("b2Title"), desc: t("b2Desc") },
    { icon: UserCheck, title: t("b3Title"), desc: t("b3Desc") },
    { icon: AlertTriangle, title: t("b4Title"), desc: t("b4Desc") },
  ];
  return (
    <section data-testid="before-you-go-section" className="px-6 py-5">
      <SectionHeading index="05" eyebrow="Before You Go" title={t("beforeHeading")} testId="before-you-go-heading" />
      <div className="grid grid-cols-2 gap-2.5">
        {ITEMS.map((item, i) => (
          <Reveal key={item.title} delay={i * 0.05}>
            <div
              data-testid={`before-you-go-item-${i + 1}`}
              className="h-full rounded-xl border border-[rgba(22,99,230,0.12)] bg-white p-3 shadow-[0_6px_18px_-14px_rgba(11,61,145,0.25)]"
            >
              <div className="flex items-center gap-2">
                <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-[rgba(22,99,230,0.1)] text-[#1663E6]">
                  <item.icon className="h-3.5 w-3.5" strokeWidth={1.75} />
                </div>
                <h3 className="text-xs font-semibold text-[#0F1E3D]">{item.title}</h3>
              </div>
              <p className="mt-1.5 text-[10px] leading-relaxed text-slate-500">{item.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
